export default "__VITE_ASSET__CaeRvCcc__"